import axios from 'axios';
import store from '@/store';

// custom global handlers
import { isBadRequest, composeErrorWithGlobalBadRequestHandler } from '@/middlewares/axios/handler/global-http-bad-request-handler';
import { isUnauthorized, logoutOnUnauthorized } from '@/middlewares/axios/handler/global-http-unauthorized-handler';

export default function setup() {
    axios.interceptors.request.use(
        function (config) {
            config.headers['WS-SESSION-ID'] = store.getters['websocket/getSessionId'];
            return config;

        },
        function (err) {

            return Promise.reject(err);
        });

    axios.interceptors.response.use(
        function (response) {
            return response
        },
        function (error) {
            if (isBadRequest(error)) { error = composeErrorWithGlobalBadRequestHandler(error) }
            if (isUnauthorized(error)) { return logoutOnUnauthorized(error) }
          
            return Promise.reject(error);
        }
    )
}
